import PropTypes from "prop-types";

import i18n from "../../../i18n";

import SplitButton from "../SplitButton";

import useEquipmentService from "../../../services/equipmentService";

import { useAsyncFn } from "../../../hooks/useAsync";

import { useSnackbarAlert } from "../../../context/snackbarAlert";

function ChangeEquipmentBmsReadingRequestButton(props) {
  const snackbarAlert = useSnackbarAlert();

  const { changeEquipmentBmsRequestRereading } = useEquipmentService();
  const changeEquipmentBmsRequestRereadingFn = useAsyncFn(
    changeEquipmentBmsRequestRereading
  );

  const handleChangeEquipmentBmsReadingRequest = (acceptanceValue) => {
    if (props.selectedEquipmentBmsIds.length === 0) return;

    changeEquipmentBmsRequestRereadingFn
      .execute(props.selectedEquipmentBmsIds, acceptanceValue)
      .then(() => {
        if (props.onSubmit) props.onSubmit();
        snackbarAlert.openSuccessSnackbarAlert(
          i18n.t("snackbar_alert.saved_changes")
        );
      })
      .catch(() => {
        snackbarAlert.openErrorSnackbarAlert(
          i18n.t("snackbar_alert.occurred_error_during_saving_changes")
        );
      });
  };

  const massActions = [
    {
      label: i18n.t(`true`),
      callback: () => handleChangeEquipmentBmsReadingRequest(true),
    },
    {
      label: i18n.t(`false`),
      callback: () => handleChangeEquipmentBmsReadingRequest(false),
    },
  ];

  return (
    <>
      <SplitButton
        label={i18n.t("bar.tool_bar.rereading_requested")}
        withChangeSelectedItem={false}
        color={props.color}
        options={massActions}
      />
    </>
  );
}

ChangeEquipmentBmsReadingRequestButton.propTypes = {
  color: PropTypes.string,
  selectedEquipmentBmsIds: PropTypes.array,
  onSubmit: PropTypes.func,
};

ChangeEquipmentBmsReadingRequestButton.defaultProps = {
  color: "error",
  selectedEquipmentBmsIds: [],
};

export default ChangeEquipmentBmsReadingRequestButton;
